import { useCallback, useEffect, useMemo } from "react";
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { useGetRequest } from "../../ApiWrappers/useGetRequest";

export interface IClinic {
    clinicId: string;
    name: string;
    countryName: string;
    address: string;
}

export interface IPartnerClinicDetails{
    distributorId: string;
    name: string;
    clinics: IClinic[];
}

export const useGetPartnersClinicInfo = () =>{
  const baseUrl = useMemo(() => Config.GetConfigData().serviceUrl,[]);
  const scope = Config.GetConfigData().auraWebService?.scopes[0];
  const requestUrl = `${baseUrl}api/v1/aura-support/distributor`;
  const [getDetails, data, loading, error] = useGetRequest<IPartnerClinicDetails[]>()
  useEffect(() => {
    getDetails(scope, requestUrl)
 },[getDetails, baseUrl, scope, requestUrl])

 const getPartnersClinicsInfo = useCallback(() => {
  getDetails(scope, requestUrl) 
 },[getDetails, scope,  requestUrl])
    return { 
      getPartnersClinicsInfo,
      data,
      loading,
      error
   };
}